
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[slug]",
      function () {
        return require("private-next-pages/company/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/[slug]"])
      });
    }
  